function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home---Sticky-Table",
  transform: "translate(-205.000000, -202.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(151.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-30",
  transform: "translate(30.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Summary"
}, /*#__PURE__*/React.createElement("g", {
  id: "Total-Revenue"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(24.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#623E93",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5293113,17 C16.2358499,17.001234 15.9988885,17.252387 16.0000039,17.5610032 L16.0000039,29.0539231 C15.9988885,29.3625394 16.2358499,29.6136924 16.5293113,29.6149263 L22.7740515,29.6149263 L22.7740515,30.8820937 L21.3262517,30.8820937 C21.1336113,30.8776205 20.9537557,30.9831419 20.8561866,31.1578812 C20.7586176,31.3326204 20.7586176,31.5492078 20.8561866,31.7239471 C20.9537557,31.8986864 21.1336113,32.0042078 21.3262517,31.9998713 L27.6737395,31.9998713 C27.8663799,32.0042078 28.0462355,31.8986864 28.1438045,31.7239471 C28.2413736,31.5492078 28.2413736,31.3326204 28.1438045,31.1578812 C28.0462355,30.9831419 27.8663799,30.8776205 27.6737395,30.8820937 L26.2259391,30.8820937 L26.2259391,29.6149263 L32.4706779,29.6149263 C32.7641404,29.6136942 33.0011037,29.3625406 32.9999883,29.0539231 L32.9999883,17.5610032 C33.0011037,17.2523857 32.7641404,17.0012322 32.4706779,17 L16.5293113,17 Z M17.0586146,18.1187307 L31.9413767,18.1187307 L31.9413767,28.4972855 L25.6966358,28.4972855 L23.2525004,28.4972855 L17.0586146,28.4972855 L17.0586146,18.1187307 Z M23.8368095,29.6149263 L25.1631813,29.6149263 L25.1631813,30.8820937 L23.8368095,30.8820937 L23.8368095,29.6149263 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))))));
function SvgLinearTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearTv);
export default __webpack_public_path__ + "static/media/linearTv.cd997d5917cc418b9aed61b12323c493.svg";
export { ForwardRef as ReactComponent };